module.exports = __webpack_public_path__ + "img/customer.bb2c2f8b.svg";